module.exports = __webpack_public_path__ + "img/bancontact.2106c2ee.svg";